import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { resolvePublicUrl } from '../../utils/publicUrl';
import { getWvSealOneColorPath } from '../../services/wvBrandingConfig';
import { FAQ_CTA_BAND_BG, FAQ_SEAL_WATERMARK_OPACITY } from '../../theme/faqCtaMock';
import { FaqCtaSharedSealContext } from './FaqCtaBandContext';
/**
 * One large WV seal watermark spanning FAQ + “Ready to Get Started?” (matches full-page mock).
 */
export const LandingFaqCtaBand = ({ children }) => {
    const raw = getWvSealOneColorPath();
    const sealSrc = (resolvePublicUrl(raw) ?? raw).replace(/ /g, '%20');
    return (_jsx(FaqCtaSharedSealContext.Provider, { value: true, children: _jsxs(Box, { className: "cms-faq-cta-band", sx: {
                position: 'relative',
                overflowX: 'clip',
                overflowY: 'visible',
                isolation: 'isolate',
                bgcolor: FAQ_CTA_BAND_BG,
                maxWidth: '100%',
                minWidth: 0,
            }, children: [_jsx(Box, { component: "img", src: sealSrc, alt: "", "aria-hidden": true, sx: {
                        position: 'absolute',
                        right: { xs: '-8%', sm: '-6%', md: '-5%' },
                        bottom: { xs: '-14%', sm: '-12%', md: '-10%' },
                        /* Decorative watermark — larger footprint, but softly faded like the mock reference. */
                        width: { xs: '74%', sm: '56%', md: '44%' },
                        maxWidth: { xs: 460, md: 560 },
                        height: 'auto',
                        opacity: FAQ_SEAL_WATERMARK_OPACITY,
                        objectFit: 'contain',
                        objectPosition: 'right bottom',
                        filter: 'grayscale(100%) contrast(0.88)',
                        pointerEvents: 'none',
                        userSelect: 'none',
                        zIndex: 2,
                    } }), _jsx(Box, { sx: { position: 'relative', zIndex: 1, bgcolor: 'transparent' }, children: children })] }) }));
};
